// Generated by GitHub Copilot
import { useTranslation } from 'react-i18next'
import { useCustomState } from '#core/state/State.ts'
import { cn } from '#core/utils/cn.ts'
import MicrosoftLogo from '#components/primitives/icons/microsoft-logo.tsx'
import { SsoRedirectState } from '../sso-redirect-state.ts'

interface MicrosoftRedirectButtonProps {
  label: string
  /** Sends the browser to Microsoft; rejects when the backend cannot start the round trip. */
  start: () => Promise<void>
  /** Stretch the button over the full width, as on the login card. */
  block?: boolean
  small?: boolean
  className?: string
}

/** Outline button with the Microsoft logo that starts a Microsoft round trip, explaining below it when that fails. */
export function MicrosoftRedirectButton({ label, start, block = false, small = false, className }: MicrosoftRedirectButtonProps) {
  const { t } = useTranslation('auth')
  const state = useCustomState(() => new SsoRedirectState())

  return (
    <div className={className}>
      <button
        type="button"
        className={cn('btn btn-outline-secondary d-inline-flex align-items-center justify-content-center gap-2', block && 'w-100', small && 'btn-sm')}
        disabled={state.busy}
        onClick={() => void state.go(start)}
      >
        <MicrosoftLogo size={small ? 16 : 18} aria-hidden="true" />
        {label}
        {state.busy && <span className="spinner-border spinner-border-sm" aria-hidden="true" />}
      </button>
      {state.notice && (
        <div className="text-danger small mt-2" role="alert">
          {t(`sso.notice.${state.notice}`)}
        </div>
      )}
    </div>
  )
}
